module.exports = __webpack_public_path__ + "img/header-climbing.8c076f8b.svg";